import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children"],
  _excluded2 = ["children", "gap"],
  _excluded3 = ["children"],
  _excluded4 = ["children"];
import { ButtonIconOnly, LayoutBox, LayoutGrid, LayoutSpaceVertical } from 'breeze-intelligence-kit';
import { NextIcon } from 'foundations-assets';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const ProductItem = _ref => {
  let {
      children
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx(LayoutGrid, Object.assign({
    gridTemplateColumns: "1fr 2rem"
  }, rest, {
    children: children
  }));
};
const ProductItemGroup = _ref2 => {
  let {
      children,
      gap = 'space'
    } = _ref2,
    rest = _objectWithoutPropertiesLoose(_ref2, _excluded2);
  return /*#__PURE__*/_jsx(LayoutSpaceVertical, Object.assign({
    gap: gap
  }, rest, {
    children: children
  }));
};
const Content = _ref3 => {
  let {
      children
    } = _ref3,
    rest = _objectWithoutPropertiesLoose(_ref3, _excluded3);
  return /*#__PURE__*/_jsx(LayoutBox, Object.assign({}, rest, {
    children: children
  }));
};
const Name = ({
  children
}) => {
  return /*#__PURE__*/_jsxs("strong", {
    children: [children, ": "]
  });
};
const Description = _ref4 => {
  let {
      children
    } = _ref4,
    rest = _objectWithoutPropertiesLoose(_ref4, _excluded4);
  return /*#__PURE__*/_jsx(LayoutBox, Object.assign({
    as: "span"
  }, rest, {
    children: children
  }));
};
const Button = ({
  href
}) => {
  return /*#__PURE__*/_jsx(ButtonIconOnly, {
    href: href,
    size: "sm",
    variant: "secondary",
    children: /*#__PURE__*/_jsx(NextIcon, {})
  });
};
ProductItem.Button = Button;
ProductItem.Content = Content;
ProductItem.Description = Description;
ProductItem.Group = ProductItemGroup;
ProductItem.Name = Name;